<template>
    <v-container fluid>
        <v-img src="@/assets/race26/DSC_1868.JPG" gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0.7)" class="landing-img" />
        <CarIntroduction />
        <v-img src="@/assets/race26/DSC_1886.JPG" gradient="to top, rgba(0,0,0,0), rgba(0,0,0,0.7)" class="landing-img" >
            <div class="car-info-container">
                <CarInfo class="car-info"/>
            </div>
        </v-img>
    </v-container>
</template>

<script>
import CarIntroduction from "@/components/car/CarIntroduction";
import CarInfo from "@/components/car/CarInfo.vue"


export default {
    name: "OurCar",
    components: {
        CarIntroduction,
        CarInfo
    },
};
</script>

<style lang="scss" scoped>
.landing-img {
    .landing-container {
        color: white;
        width: 100%;
        height: 100%;
        padding: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-shadow: 2px 2px 2px #000000;
    }
}

.car-info-container {
    $margin: 200px;
    margin: $margin 0 $margin 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .car-info {
        width: 80%;
        max-width: 1300px;
    }
}

.adopt-a-cell-container {
    $margin: 100px;
    margin: $margin 0 $margin 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;

    .adopt-a-cell {
        width: 80%;
        max-width: 1300px;
    }
}

</style>
